import { render, staticRenderFns } from "./PromoServiceList.vue?vue&type=template&id=c467c0e6&scoped=true&"
import script from "./PromoServiceList.vue?vue&type=script&lang=js&"
export * from "./PromoServiceList.vue?vue&type=script&lang=js&"
import style0 from "./PromoServiceList.vue?vue&type=style&index=0&id=c467c0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c467c0e6",
  null
  
)

export default component.exports